import React from 'react';

type HamburgerMenuProps = {
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
  links: Array<{ label: string; to: string; isActive?: boolean }>;
};

export default function HamburgerMenu({ isOpen, onToggle, onClose, links }: HamburgerMenuProps) {
  if (!isOpen) {
    return (
      <div className="hamburgerWrap" aria-hidden="true">
        <button
          type="button"
          className="hamburgerButton"
          aria-label="Open menu"
          aria-expanded={false}
          onClick={onToggle}
        >
          <span className="hamburgerLines" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>
      </div>
    );
  }
  const containerRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (!isOpen) return;

    const onPointerDown = (e: PointerEvent) => {
      const el = containerRef.current;
      if (!el) return;
      if (e.target instanceof Node && !el.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, [isOpen, onClose]);

  return (
    <div ref={containerRef} className="hamburgerWrap">
      <button
        type="button"
        className={`hamburgerButton ${isOpen ? 'open' : ''}`}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded="true"
        onClick={onToggle}
      >
        <span className="hamburgerLines" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </button>

      <div className={`hamburgerDropdown ${isOpen ? 'open' : ''}`} role="menu">
        {links.map((l) => (
          <a
            key={l.to}
            href={l.to}
            className="hamburgerMenuLink"
            role="menuitem"
            onClick={onClose}
          >
            {l.label}
          </a>
        ))}
      </div>
    </div>
  );
}

